// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { PrimaryButton, Spinner, Stack } from '@fluentui/react';
import { EmojiSad24Regular } from '@fluentui/react-icons';

export const BotServerError = (props: { filingIssue?: boolean }): JSX.Element => {
  const text = props.filingIssue
    ? 'Filing issue, please wait...'
    : 'An issue has been logged internally. Please try again.';

  return (
    <Stack horizontalAlign="center" verticalFill verticalAlign="center" tokens={{ childrenGap: '1rem' }}>
      <Stack.Item>
        <EmojiSad24Regular />
      </Stack.Item>
      <Stack.Item>Server ran into a problem. {text}</Stack.Item>
      <Stack.Item>{props.filingIssue ? <FilingIssueSpinner /> : <ReloadButton />}</Stack.Item>
    </Stack>
  );
};

const FilingIssueSpinner = (): JSX.Element => {
  return <Spinner aria-label="Filing issue" />;
};

const ReloadButton = (): JSX.Element => {
  return (
    <PrimaryButton
      onClick={() => {
        window.location.reload();
      }}
    >
      Reload
    </PrimaryButton>
  );
};
